module.exports = __webpack_public_path__ + "static/media/chinese_01.7f7980cb.jpg";